import { useOnline } from '@/hooks/useOnline'

import styles from './AppShell.module.css'

/** Shown while the phone has no connection; pages already opened still show (D-63). */
export function OfflineBanner() {
  const online = useOnline()
  if (online) return null
  return (
    <output className={styles.offline}>
      You’re offline. Showing what was saved on this phone.
    </output>
  )
}
